import { FontAwesome, Ionicons } from "@expo/vector-icons";
import {
	Box,
	Button,
	Divider,
	FormControl,
	Heading,
	Icon,
	IconButton,
	Input,
	InputGroup,
	InputLeftAddon,
	InputRightAddon,
	Modal,
	Text,
	Tooltip,
	useDisclose,
	useMediaQuery,
	useTheme,
	VStack,
	WarningOutlineIcon,
} from "native-base";
import React, { useEffect, useState } from "react";
import { Dimensions, FlatList, TouchableOpacity, View } from "react-native";
import { useDispatch, useSelector } from "react-redux";
import api_comm from "../../common/lib";
import {
	ComponentButton,
	ComponentButtonGroup,
	ComponentCenter,
	ComponentFlatList,
	ComponentForm,
	ComponentHeading,
	ComponentHStack,
	ComponentInput,
	ComponentMenu,
	ComponentMenuGroup,
	ComponentStack,
	ComponentText,
	ComponentView,
	ComponentVStack,
	currencyFormat,
	dataFilter,
} from "../../components/dynamic/ComponentsGenerator";
import ErrorToast from "../../components/ErrorToast";
import Loader from "../../components/Loader";
import SuccessToast from "../../components/SuccessToast";
import { getBalance } from "../../redux/slices/BalanceSlice";
import { getCardStatement } from "../../redux/slices/CardStatementsSlice";
import { getTransactionTypes } from "../../redux/slices/TransactionTypeSlice";
import { isWeb } from "../../utils/utils";
import DateTimePicker from "@react-native-community/datetimepicker";
import dayjs from "dayjs";
import checkLinkedCard from "../../common/checkLinkedCard";

const { width, height } = Dimensions.get("window");

const KeysToComponentMap = {
	// card: (props) => ComponentCard({setHistory: (parameter) => setHistory(parameter), ...props}),
	// button: (props) => ComponentButton({setHistory: (parameter) => setHistory(parameter), ...props}),
	VIEW: (props) =>
		ComponentView({
			...props,
		}),
	TABLE: (props) =>
		ComponentFlatList({
			//setHistory: (parameter) => setHistory(parameter),
			...props,
			// extraProps: {history: history, tableData: data, keyField: 'id', 'desktop': isDesktopOrLaptop}
		}),
	BUTTON: (props) =>
		ComponentButton({
			// onSubmit: () => onSubmit(), onCancel: () => onCancel(),
			...props,
			//extraProps: {'desktop': isDesktopOrLaptop}
		}),
	BUTTON_GROUP: (props) =>
		ComponentButtonGroup({
			// setHistory: (parameter) => setHistory(parameter),
			...props,
			//extraProps: {'desktop': isDesktopOrLaptop}
		}),
	INPUT: (props) =>
		ComponentInput({
			...props,
			//setCurrentInput: (parameter) => setDates(parameter),
			// onChange: (key, value) => onChange(key, value), params: params,
			// extraProps: {'desktop': isDesktopOrLaptop}
		}),
	FORM: (props) =>
		ComponentForm({
			//setHistory: (parameter) => setHistory(parameter),
			...props,
			// extraProps: {'desktop': isDesktopOrLaptop}
		}),
	CONTENT: (props) =>
		ComponentView({
			//setHistory: (parameter) => setHistory(parameter),
			...props,
			// extraProps: {'desktop': isDesktopOrLaptop}
		}),
	HEADING: (props) =>
		ComponentHeading({
			//setHistory: (parameter) => setHistory(parameter),
			...props,
			// extraProps: {'desktop': isDesktopOrLaptop}
		}),
	MENU_GROUP: (props) =>
		ComponentMenuGroup({
			// setHistory: (parameter) => setHistory(parameter),
			...props,
			// extraProps: {'desktop': isDesktopOrLaptop}
		}),
	TEXT: (props) =>
		ComponentText({
			// setHistory: (parameter) => setHistory(parameter),
			...props,
			// extraProps: {'desktop': isDesktopOrLaptop}
		}),
	HSTACK: (props) =>
		ComponentHStack({
			//setHistory: (parameter) => setHistory(parameter),
			...props,
			//extraProps: {'desktop': isDesktopOrLaptop}
		}),
	VSTACK: (props) =>
		ComponentVStack({
			// setHistory: (parameter) => setHistory(parameter),
			...props,
			//extraProps: {'desktop': isDesktopOrLaptop}
		}),
	STACK: (props) =>
		ComponentStack({
			// setHistory: (parameter) => setHistory(parameter),
			...props,
			// extraProps: {'desktop': isDesktopOrLaptop}
		}),
	CENTER: (props) =>
		ComponentCenter({
			//setHistory: (parameter) => setHistory(parameter),
			...props,
			//extraProps: {'desktop': isDesktopOrLaptop}
		}),
	MENU: (props) =>
		ComponentMenu({
			...props,
		}),
};
const renderer = (component, isDesktopOrLaptop, hooks) => {
	if (typeof KeysToComponentMap[component.componenttype_name] !== "undefined") {
		return React.createElement(
			KeysToComponentMap[component.componenttype_name],
			{
				...component,
				desktop: isDesktopOrLaptop,
				hooks: hooks,
				key: component.sitepagecomponent_guid,
			},
			component.children_components &&
				(component.children_components === []
					? component.componenttype_name === "TEXT" ||
					  component.componenttype_name === "BUTTON"
						? component.sitepagecomponent_meta.name
						: null
					: component.children_components.map((child) =>
							renderer(child, isDesktopOrLaptop, hooks)
					  ))
		);
	}
};

const DatePicker = isWeb()
	? require("react-rainbow-components").DatePicker
	: null;
const Application = isWeb()
	? require("react-rainbow-components").Application
	: null;

const Transaction = ({ navigation, route }) => {
	const routeName = route?.name;
	const isDesktopOrLaptop = useMediaQuery({ minWidth: 960 })[0];
	const components = useSelector((state) => state.Page.Pages);
	const [transaction, setTransaction] = useState("");
	const [transactionType, setTransactionType] = useState("");
	const dispatch = useDispatch();
	const hooks = {
		component: components,
		routeName: routeName,
		transaction: transaction,
		LoadHistory: (param) => LoadHistory(param),
		Withdrawal: (param) => Withdrawal(param),
		Statements: (param) => Statements(param),
		CardLoad: (param) => CardLoad(param),
		selectedComponent: selectedComponent,
		setTransaction: (type, transactionType = "") => {
			// console.log('setTransaction', type);
			// console.log('setTransaction', transactionType);
			setTransaction(type);
			setTransactionType(transactionType);
		},
		onCancel: () => {},
		setParams: () => {},
		history: null,
		setHistory: () => {},
		tableData: [],
		setTableData: () => {},
		onChange: () => {},
		params: {},
		getData: () => {},
	};
	useEffect(() => {
		if (transaction === "Withdrawal" || transaction === "CardLoad") {
			dispatch(getTransactionTypes());
		}
	}, [transaction]);

	const LoadHistory = () => {
		return (
			<Box>
				<Text>Load History</Text>
			</Box>
		);
	};

	const selectedComponent = () => {
		return hooks[transaction];
	};

	const Settings = useSelector((state) => state.setting.Settings);

	return (
		<Box bg="#fff" padding={isDesktopOrLaptop ? 20 : 0}>
			{/* <View key="transactionComponent">
				<Heading textAlign="center" mb="10">
					{transaction === "" ? "Transactions (Select below)" : transaction}
				</Heading>
			</View> */}
			{components.length > 0 &&
				components.map((component) =>
					renderer(component, isDesktopOrLaptop, hooks)
				)}
			<Divider />
			{transaction === "Statements" && Settings?.ALLOW_CARD_STATEMENT == 1 && (
				<Statements />
			)}
			{transaction === "CardLoad" && Settings?.ALLOW_CARD_LOADS == 1 && (
				<CardLoad transactionType={transactionType} />
			)}
			{transaction === "Withdrawal" && Settings?.ALLOW_EFT_WITHDRAWALS == 1 && (
				<Withdrawal transactionType={transactionType} />
			)}
			{transaction === "LoadHistory" && Settings?.ALLOW_CARD_STATEMENT == 1 && (
				<LoadHistory />
			)}
		</Box>
	);
};

const Withdrawal = ({ transactionType }) => {
	const transactionTypes = useSelector(
		(state) => state.TransactionType.TransactionTypes
	);
	const Loading = useSelector((state) => state.TransactionType.loading);
	const [submitting, setSubmitting] = useState(false);
	// console.log(transactionType);
	// console.log('Loading', Loading);
	const Auth = useSelector((state) => state.Login.Auth);
	const balance = useSelector((state) => state.balance.Balance);
	// console.log(balance);
	// console.log('transactionTypes', transactionTypes);
	const { profile } = Auth;
	const { data } = profile;
	const cellphone = dataFilter(data, "type_name", "mobile_number")?.data_text;
	// console.log('Auth', cellphone);
	let transactionTypeGuid = dataFilter(
		transactionTypes,
		"transaction_type_code",
		transactionType
	)?.transactiontype_guid;
	// console.log(transactionTypeGuid);
	const [value, setValue] = useState(0);
	const [isFormValid, setIsFormValid] = useState(false);
	// console.log(isFormValid);
	const handleChange = (amount) => {
		// console.log('AMNT::', amount);
		if (amount.replace(/\D+/g, "") > balance / 100) {
			ErrorToast(
				`You cannot withdrawal above ${balance / 100}`,
				"Maximum request exceeded"
			);
			setIsFormValid(false);
		} else if (
			amount.replace(/\D+/g, "") >= 100 &&
			amount.replace(/\D+/g, "") <= 5000
		) {
			setIsFormValid(true);
			setValue(amount.replace(/\D+/g, ""));
		} else if (amount.replace(/\D+/g, "") < 100) {
			setIsFormValid(false);
			setValue(amount.replace(/\D+/g, ""));
		} else {
			setIsFormValid(false);
			ErrorToast("Enter a valid amount", "Invalid amount entered");
			setValue(Number(amount.replace(/\D+/g, ""))?.toString().substring(0, 4));
			setIsFormValid(true);
		}
		// console.log("AMNT:: 2", amount);
	};

	const submitRequest = () => {
		setSubmitting(true);
		api_comm(
			"post",
			`/finances/api/v2/wallet/withdrawal/${cellphone}/${transactionTypeGuid}`,
			{ amount: value * 100 },
			Auth.session_token
		)
			.then((response) => {
				setSubmitting(false);
				setValue(0);
				SuccessToast(
					"Withdrawal Request was successfully submitted",
					"Success"
				);
				// console.log(response);
			})
			.catch((err) => {
				setSubmitting(false);
				console.log("ER:::", err);
				// ErrorToast(err);
			})
			.finally(() => {
				dispatch(getBalance());
			});
	};
	return (
		<Box>
			<Heading my={2}>Cash withdrawal request</Heading>
			<Box bg="#888888">
				<Text color="white" p={2}>
					Please note: Your card balance will only reflect once the transfer has
					been authorised.
				</Text>
			</Box>
			<Box>
				<FormControl isInvalid={!isFormValid}>
					<VStack style={{ width: "100%" }}>
						<FormControl.Label my={5}>
							Minimum amount to transfer is R 100.00, maximum amount is R
							5,000.00
						</FormControl.Label>
						<InputGroup my={2}>
							<InputLeftAddon children={"R"} />
							<Input
								variant="outline"
								keyboardType="number-pad"
								style={{ flex: 1 }}
								placeholder="Enter Amount"
								value={value}
								onChangeText={(value) => handleChange(value)}
							/>
							<InputRightAddon
								children={`Balance: ${currencyFormat(balance / 100)}`}
							/>
						</InputGroup>
						<FormControl.ErrorMessage
							leftIcon={<WarningOutlineIcon size="xs" />}
						>
							Enter a valid amount
						</FormControl.ErrorMessage>
						<Button
							maxW={500}
							mx={5}
							isDisabled={!isFormValid}
							isLoading={submitting}
							isLoadingText="Submitting request..."
							onPress={submitRequest}
						>
							Submit
						</Button>
					</VStack>
				</FormControl>
			</Box>
			<Loader loading={Loading} text="Loading data..." />
		</Box>
	);
};

const CardLoad = ({ transactionType }) => {
	const dispatch = useDispatch();
	const transactionTypes = useSelector(
		(state) => state.TransactionType.TransactionTypes
	);
	const Loading = useSelector((state) => state.TransactionType.loading);
	const [submitting, setSubmitting] = useState(false);
	// console.log(transactionType);
	// console.log('Loading', Loading);
	const Auth = useSelector((state) => state.Login.Auth);
	const balance = useSelector((state) => state.balance.Balance);
	// console.log(balance);
	// console.log('transactionTypes', transactionTypes);
	const { profile } = Auth;
	const { data } = profile;
	const cellphone = dataFilter(data, "type_name", "mobile_number")?.data_text;
	// console.log('Auth', cellphone);
	let transactionTypeGuid = dataFilter(
		transactionTypes,
		"transaction_type_code",
		transactionType
	)?.transactiontype_guid;
	// console.log(transactionTypeGuid);
	const [value, setValue] = useState(0);
	const [isFormValid, setIsFormValid] = useState(false);
	// console.log(isFormValid);

	const handleChange = (amount) => {
		// console.log('AMNT::', amount);
		if (amount.replace(/\D+/g, "") > balance / 100) {
			ErrorToast(
				`You cannot withdrawal above ${balance / 100}`,
				"Maximum request exceeded"
			);
			setIsFormValid(false);
		} else if (
			amount.replace(/\D+/g, "") >= 100 &&
			amount.replace(/\D+/g, "") <= 5000
		) {
			setIsFormValid(true);
			setValue(amount.replace(/\D+/g, ""));
		} else if (amount.replace(/\D+/g, "") < 100) {
			setIsFormValid(false);
			setValue(amount.replace(/\D+/g, ""));
		} else {
			console.log("Else");
			setIsFormValid(false);
			ErrorToast("Enter a valid amount", "Invalid amount entered");
			setValue(Number(amount.replace(/\D+/g, ""))?.toString().substring(0, 4));
			setIsFormValid(true);
		}
		// console.log("AMNT:: 2", amount);
	};

	const submitRequest = async () => {
		setSubmitting(true);

		try {
			let cardLoadStatus = await checkLinkedCard(
				Auth.session_token,
				Auth.storemember_guid
			);
		} catch (error) {
			ErrorToast(
				"No card linked, please activate card via Manage Card",
				"Card Load"
			);
			setSubmitting(false);

			return;
		}

		try {
			let cardLoadResult = await api_comm(
				"post",
				`/finances/api/v2/wallet/withdrawal/${cellphone}/${transactionTypeGuid}`,
				{ amount: value * 100 },
				Auth.session_token
			);

			setSubmitting(false);
			setValue(0);
			SuccessToast("Card Load Request successfully submitted", "Success");
			dispatch(getBalance());
		} catch (error) {
			setSubmitting(false);
			console.log("ER:::", error);

			if (error.data?.error) {
				ErrorToast(error.data?.error, "Card Load");
			} else {
				ErrorToast(error.message, "Card Load");
			}
		}

		// api_comm(
		// 	"post",
		// 	`/finances/api/v2/wallet/withdrawal/${cellphone}/${transactionTypeGuid}`,
		// 	{ amount: value * 100 },
		// 	Auth.session_token
		// )
		// 	.then((response) => {
		// 		setSubmitting(false);
		// 		setValue(0);
		// 		SuccessToast("Card Load Request successfully submitted", "Success");
		// 		// console.log(response);
		// 	})
		// 	.catch((err) => {
		// 		setSubmitting(false);
		// 		console.log("ER:::", err);
		// 		// ErrorToast(err);
		// 	})
		// 	.finally(() => {
		// 		dispatch(getBalance());
		// 	});
	};

	return (
		<Box>
			<Heading fontWeight="900" my={2}>
				Card load request
			</Heading>
			<Box bg="#888888">
				<Text color="white" p={2}>
					Please note: Your card balance will only reflect once the transfer has
					been authorised.
				</Text>
			</Box>
			<Box>
				<FormControl isInvalid={!isFormValid}>
					<VStack style={{ width: "100%" }}>
						<FormControl.Label my={5}>
							Minimum amount to transfer is R 100.00, maximum amount is R
							5,000.00
						</FormControl.Label>
						<InputGroup my={2}>
							<InputLeftAddon children={"R"} />
							<Input
								variant="outline"
								keyboardType="number-pad"
								style={{ flex: 1 }}
								placeholder="Enter Amount"
								value={value}
								onChangeText={(value) => handleChange(value)}
							/>
							<InputRightAddon
								children={`Balance: ${currencyFormat(balance / 100)}`}
							/>
						</InputGroup>
						<FormControl.ErrorMessage
							leftIcon={<WarningOutlineIcon size="xs" />}
						>
							Enter a valid amount
						</FormControl.ErrorMessage>
						<Button
							maxW={500}
							mx={5}
							isDisabled={!isFormValid}
							isLoading={submitting}
							isLoadingText="Submitting request..."
							variant={submitting ? "outline" : "solid"}
							onPress={submitRequest}
						>
							Submit
						</Button>
					</VStack>
				</FormControl>
			</Box>
			<Loader loading={Loading} text="Loading data..." />
		</Box>
	);
};

const Statements = () => {
	const isDesktopOrLaptop = useMediaQuery({ minWidth: 960 })[0];
	const dispatch = useDispatch();
	const { isOpen, onOpen, onClose } = useDisclose();
	const [showFromDate, setShowFromDate] = useState(false);
	const [showToDate, setShowToDate] = useState(false);
	const [selectedItem, setSelectedItem] = useState({});
	const [showFilter, setShowFilter] = useState(false);
	const [fromDate, setFromDate] = useState(
		dayjs(new Date()).format("YYYY-MM-DD")
	);
	const [toDate, setToDate] = useState(dayjs(new Date()).format("YYYY-MM-DD"));

	const Auth = useSelector((state) => state.Login.Auth);
	const CardStatement = useSelector((state) => state.CardStatement.Statements);
	const Loading = useSelector((state) => state.CardStatement.loading);

	const { colors } = useTheme();
	const theme = {
		rainbow: {
			palette: {
				brand: colors.primary["400"],
			},
		},
	};

	useEffect(() => {
		getCardStatements();
	}, []);

	const getCardStatements = () => {
		let params = {
			storemember_guid: Auth.storemember_guid,
			from_date: fromDate,
			to_date: toDate,
		};
		dispatch(getCardStatement(params));
	};

	return (
		<Box marginTop={5}>
			<FlatList
				stickyHeaderIndices={[0]}
				style={{ height: height / 1.6 }}
				data={CardStatement}
				ListEmptyComponent={() => (
					<Text
						style={{ alignSelf: "center", marginTop: 50, color: "#D5D5D5" }}
					>
						No transactions for the specified date
					</Text>
				)}
				renderItem={({ item }) => {
					return (
						<TouchableOpacity
							onPress={() => {
								setSelectedItem(item);
								onOpen();
							}}
							style={{
								flexDirection: "row",
								justifyContent: "space-between",
								borderWidth: 1,
								borderColor: "#D5D5D5",
								padding: 5,
								margin: 1.5,
								borderRadius: 5,
							}}
						>
							<View style={{ flex: 4 }}>
								<Text
									fontWeight="900"
									numberOfLines={1}
									style={{ fontSize: 12 }}
								>
									{item.description}
								</Text>
								<Text style={{ fontSize: 12 }}>{item.date}</Text>
							</View>
							<View
								style={{
									flex: 1,
									alignItems: "flex-end",
								}}
							>
								<Text fontWeight="900" style={{ color: "#7dff95" }}>
									{currencyFormat(item.credit / 100)}
								</Text>
								<Text fontWeight="900" style={{ color: "#ff7645" }}>
									{currencyFormat(item.debit / 100)}
								</Text>
							</View>
							{!isWeb() && (
								<View
									style={{
										alignItems: "center",
										justifyContent: "center",
										padding: 5,
										marginLeft: 10,
									}}
								>
									<Icon
										color="#D5D5D5"
										size="xs"
										as={<FontAwesome name="chevron-right" />}
									/>
								</View>
							)}
						</TouchableOpacity>
					);
				}}
				ListHeaderComponent={() => (
					<Box
						style={{
							borderWidth: 1,
							borderColor: "#D5D5D5",
							padding: 5,
							margin: 1.5,
							borderRadius: 5,
							backgroundColor: "#fff",
						}}
					>
						<Tooltip label="Filter the results" openDelay={500}>
							<Button
								variant="ghost"
								key="filterBtn"
								onPress={() => setShowFilter(!showFilter)}
								style={{ alignSelf: "flex-end" }}
								startIcon={
									<Icon
										color="primary.500"
										size="sm"
										as={<FontAwesome name="filter" />}
									/>
								}
							>
								Filter
							</Button>
						</Tooltip>
						<View>
							{showFilter && (
								<FormControl>
									<View>
										<FormControl.Label>{`From`}</FormControl.Label>
										{isWeb() ? (
											<Application theme={theme}>
												<DatePicker
													onChange={(value) =>
														setFromDate(dayjs(value).format("YYYY-MM-DD"))
													}
													value={fromDate}
													placehplaceholder={`From`}
													formatStyle="medium"
													maxDate={new Date()}
													locale="en-ZA"
													style={{
														fontFamily: "NotoSans-Regular",
														fontSize: 10,
													}}
												/>
											</Application>
										) : (
											<>
												<Input
													onPressIn={() => showFromDate(true)}
													onChangeText={(value) =>
														setFromDate(dayjs(value).format("YYYY-MM-DD"))
													}
													showSoftInputOnFocus={false}
													value={fromDate}
													type="text"
													InputRightElement={
														<IconButton
															size="sm"
															onPress={() => setShowFromDate(true)}
															_icon={{
																as: Ionicons,
																name: "calendar",
																color: "primary.500",
																size: "sm",
															}}
														></IconButton>
													}
													// isDisabled={true}
													// placeholder={`${control.datatype_label} format YYYY-MM-DD`}
												/>
												{showFromDate && (
													<DateTimePicker
														maximumDate={new Date()}
														mode="date"
														is24Hour={true}
														display="default"
														value={new Date(fromDate)}
														onChange={(event, value) => {
															setShowFromDate(false);
															setFromDate(dayjs(value).format("YYYY-MM-DD"));
														}}
													/>
												)}
											</>
										)}
									</View>
									<View>
										<FormControl.Label>{`To`}</FormControl.Label>
										{isWeb() ? (
											<Application theme={theme}>
												<DatePicker
													onChange={(value) =>
														setToDate(dayjs(value).format("YYYY-MM-DD"))
													}
													value={toDate}
													formatStyle="medium"
													maxDate={new Date()}
													locale="en-ZA"
													style={{
														fontFamily: "NotoSans-Regular",
														fontSize: 10,
													}}
												/>
											</Application>
										) : (
											<>
												<Input
													onPressIn={() => setShowToDate(true)}
													onChangeText={(value) =>
														setToDate(dayjs(value).format("YYYY-MM-DD"))
													}
													showSoftInputOnFocus={false}
													value={toDate}
													type="text"
													InputRightElement={
														<IconButton
															size="sm"
															onPress={() => setShowToDate(true)}
															_icon={{
																as: Ionicons,
																name: "calendar",
																color: "primary.500",
																size: "sm",
															}}
														></IconButton>
													}
													// isDisabled={true}
													// placeholder={`${control.datatype_label} format YYYY-MM-DD`}
												/>
												{showToDate && (
													<DateTimePicker
														maximumDate={new Date()}
														mode="date"
														is24Hour={true}
														display="default"
														value={new Date(toDate)}
														onChange={(event, value) => {
															setShowToDate(false);
															setToDate(dayjs(value).format("YYYY-MM-DD"));
														}}
													/>
												)}
											</>
										)}
									</View>
									<Button
										onPress={() => getCardStatements()}
										marginVertical={8}
										style={
											isDesktopOrLaptop
												? {
														marginLeft: "auto",
														marginTop: "10px",
												  }
												: {}
										}
									>
										Filter
									</Button>
								</FormControl>
							)}
						</View>
					</Box>
				)}
				keyExtractor={(item) => item.id}
			/>
			<Modal isOpen={isOpen} onClose={onClose}>
				<Modal.Content>
					<Modal.CloseButton />
					<Modal.Header>Transaction Details</Modal.Header>
					<Modal.Body>
						<View>
							<View
								style={{
									flexDirection: "row",
									margin: 2,
									borderBottomColor: "#D5D5D5",
									borderBottomWidth: 1,
								}}
							>
								<View style={{ flex: 1 }}>
									<Text>Description:</Text>
								</View>
								<View style={{ flex: 1 }}>
									<Text fontWeight="900">{selectedItem.description}</Text>
								</View>
							</View>
							<View
								style={{
									flexDirection: "row",
									margin: 2,
									borderBottomColor: "#D5D5D5",
									borderBottomWidth: 1,
								}}
							>
								<View style={{ flex: 1 }}>
									<Text>Date Created:</Text>
								</View>
								<View style={{ flex: 1 }}>
									<Text fontWeight="900">{selectedItem.create_date}</Text>
								</View>
							</View>
							<View
								style={{
									flexDirection: "row",
									margin: 2,
									borderBottomColor: "#D5D5D5",
									borderBottomWidth: 1,
								}}
							>
								<View style={{ flex: 1 }}>
									<Text>Date Cleared:</Text>
								</View>
								<View style={{ flex: 1 }}>
									<Text fontWeight="900">{selectedItem.clearedDate}</Text>
								</View>
							</View>
							<View
								style={{
									flexDirection: "row",
									margin: 2,
									borderBottomColor: "#D5D5D5",
									borderBottomWidth: 1,
								}}
							>
								<View style={{ flex: 1 }}>
									<Text>Credit:</Text>
								</View>
								<View style={{ flex: 1 }}>
									<Text fontWeight="900" style={{ color: "#7dff95" }}>
										{currencyFormat(selectedItem.credit / 100)}
									</Text>
								</View>
							</View>
							<View
								style={{
									flexDirection: "row",
									margin: 2,
									borderBottomColor: "#D5D5D5",
									borderBottomWidth: 1,
								}}
							>
								<View style={{ flex: 1 }}>
									<Text>Debit:</Text>
								</View>
								<View style={{ flex: 1 }}>
									<Text fontWeight="900" style={{ color: "#ff7645" }}>
										{currencyFormat(selectedItem.debit / 100)}
									</Text>
								</View>
							</View>
							<View
								style={{
									flexDirection: "row",
									margin: 2,
									borderBottomColor: "#D5D5D5",
									borderBottomWidth: 1,
								}}
							>
								<View style={{ flex: 1 }}>
									<Text>Transaction ID:</Text>
								</View>
								<View style={{ flex: 1 }}>
									<Text fontWeight="900">{selectedItem.transId}</Text>
								</View>
							</View>
						</View>
					</Modal.Body>
					<Modal.Footer>
						<Button variant="ghost" colorScheme="blueGray" onPress={onClose}>
							Cancel
						</Button>
					</Modal.Footer>
				</Modal.Content>
			</Modal>
		</Box>
	);
};

export default Transaction;
